import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { IOperationResultNoValue } from '../../surveys/models/Api';

export const useClientDeleteSurveyAttachmentByToken = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IOperationResultNoValue) => void;
	onSuccess?: () => void;
}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: async ({
			attachmentId,
			accessToken,
			surveyType,
		}: {
			attachmentId: string;
			accessToken: string;
			surveyType: 'custom' | 'donation' | 'eventRegistration';
		}) => {
			await apiClient.delete<IOperationResultNoValue>(
				`survey/${surveyType}/response/byToken/fileUpload/${attachmentId}?token=${accessToken}`
			);
		},
		onError,
		onSuccess,
	});
};
